// NATIVE

// INSTALLED

// CUSTOM
import { types } from '../../commons/types/types';
import { checkingPreload, unCheckingPreload } from '../loading';
import { hideIconRequestErrors, showIconRequestErrors } from '../errors';
import {
  setUserPemissionsAssignedRedux,
  setUserPemissionsRedux,
  setUsersPemissionsRedux,
} from './UsersPermissionsSlice';
import {
  activeUserPermission,
  convertToUserSystemService,
  createAplicationUserService,
  desactiveUserPermissionService,
  getAllUsersPermissionsService,
  getApplicationsPermissionsUserService,
  getUserPermissionsDetailService,
  getUsersPermissionsByPaginateService,
  updateAplicationUserService,
  updateUserPemissionsService,
  getUsuariosPermisosBySearchService,
} from '../../services/usersPermissions.servce';
import { customerPermissionsListRedux } from '../customer';
import { setEmployeRedux } from '../employee';
import { setApplicationsListRedux } from '../applications';
import { setPermissionsApplication } from '../permissions';

export const getUsuariosPermisosStore = (): any => {
  return async (dispatch: any) => {
    await dispatch(checkingPreload());

    const result = await getAllUsersPermissionsService();

    dispatch(unCheckingPreload());

    if (result.ok) {
      await dispatch(setUsersPemissionsRedux(result.data));
    }

    return result;
  };
};

export const getUsuariosPermisosBySearch = (param: string): any => {
  return async (dispatch: any) => {
    await dispatch(checkingPreload());

    const result = await getUsuariosPermisosBySearchService(param);

    dispatch(unCheckingPreload());

    if (result.ok) {
      await dispatch(setUsersPemissionsRedux(result.data));
    }

    return result;
  };
};

export const getApplicationsPermissionsUserStore = (
  idCustomerApplication: string,
  idCurrentUser: string
): any => {
  return async (dispatch: any) => {
    await dispatch(checkingPreload());

    const result = await getApplicationsPermissionsUserService(
      idCustomerApplication,
      idCurrentUser
    );

    if (result.ok) {
      await dispatch(setPermissionsApplication(result.data));
    }

    dispatch(unCheckingPreload());

    return result;
  };
};

// export const storeCreateTipoNovedad = (tipoNovedad: any, percentage:any): any => {

//     return async( dispatch: any ) => {

//       await dispatch( checkingPreload() );
//       await dispatch( hideIconRequestErrors() );

//       const dataTipoNovedad = {
//         name: tipoNovedad.name,
//         description: ( tipoNovedad.description ) ? tipoNovedad.description : '',
//         accion_1: ( tipoNovedad.accion_1.value ) ? tipoNovedad.accion_1.value: '',
//         resultado_1: ( tipoNovedad.resultado_1.value ) ? tipoNovedad.resultado_1.value: '',
//         cantidad_1: ( tipoNovedad.cantidad_1.value ) ? tipoNovedad.cantidad_1.value: '',
//         accion_2: ( tipoNovedad.accion_2.value ) ? tipoNovedad.accion_2.value: '',
//         resultado_2: ( tipoNovedad.resultado_2.value ) ? tipoNovedad.resultado_2.value: '',
//         cantidad_2: ( tipoNovedad.cantidad_2.value ) ? tipoNovedad.cantidad_2.value: '',
//         accion_3: ( tipoNovedad.accion_3.value ) ? tipoNovedad.accion_3.value: '',
//         resultado_3: ( tipoNovedad.resultado_3.value ) ? tipoNovedad.resultado_3.value: '',
//         cantidad_3: ( tipoNovedad.cantidad_3.value ) ? tipoNovedad.cantidad_3.value: '',
//         accion_4: ( tipoNovedad.accion_4.value ) ? tipoNovedad.accion_4.value: '',
//         resultado_4: ( tipoNovedad.resultado_4.value ) ? tipoNovedad.resultado_4.value: '',
//         cantidad_4: ( tipoNovedad.cantidad_4.value ) ? tipoNovedad.cantidad_4.value: '',
//       };

//       const result = await  createTipoNovedadService(dataTipoNovedad, percentage);

//       ( result.ok ) ? dispatch( hideIconRequestErrors() )  : dispatch( showIconRequestErrors() );

//       if ( result.ok ) {

//         if ( Object.keys(result.data).length > 0  ) {

//           // const dataResult:any = await addRowTblPaginate(types.storage.tipoNovedadesStorage, result.data );

//           if (result.ok) {

//               await dispatch( setTipoNovedadesRedux(result.data) );
//           }

//         }

//       }

//       dispatch( unCheckingPreload() );

//       return result;

//     }

// }

export const storeDesActiveUserPermission = (userPermissionId: string): any => {
  return async (dispatch: any) => {
    await dispatch(checkingPreload());

    const result = await desactiveUserPermissionService(userPermissionId);

    dispatch(unCheckingPreload());

    if (result.ok) {
      await dispatch(setUsersPemissionsRedux(result.data));
    }

    return result;
  };
};

export const storeActiveUserPermission = (userPermissionId: string): any => {
  return async (dispatch: any) => {
    await dispatch(checkingPreload());

    const result = await activeUserPermission(userPermissionId);

    dispatch(unCheckingPreload());

    if (result.ok) {
      await dispatch(setUsersPemissionsRedux(result.data));
    }

    return result;
  };
};

export const storeConvertToUserSystem = (
  userPermissionId: string,
  selectedApps: any,
  setPercentajeEmployee: any
): any => {
  return async (dispatch: any) => {
    await dispatch(checkingPreload());

    const dataSave = {
      employeeId: userPermissionId,
      apps: selectedApps,
    };

    const result = await convertToUserSystemService(dataSave, setPercentajeEmployee);

    dispatch(unCheckingPreload());

    if (result.ok) {
      // await dispatch( setUsersPemissionsRedux(result.data) );
      await dispatch(setEmployeRedux(result.data));
    }

    return result;
  };
};

export const updateAplicationUser = (
  aplicationId: string,
  employeeId: string,
  status: any,
  setPercentajeEmployee: any
): any => {
  return async (dispatch: any) => {
    const dataSave = {
      aplicationId: aplicationId,
      employeeId: employeeId,
      status: status,
    };

    const result = await updateAplicationUserService(dataSave, setPercentajeEmployee);

    return result;
  };
};

export const createAplicationUser = (
  employeeId: string,
  appsUser: any,
  setPercentajeEmployee: any
): any => {
  return async (dispatch: any) => {
    const dataSave = {
      employeeId: employeeId,
      appsUser: appsUser,
    };

    const result = await createAplicationUserService(dataSave, setPercentajeEmployee);

    return result;
  };
};
export const getUsuariosPermisosByPagination = (page: number): any => {
  return async (dispatch: any) => {
    await dispatch(checkingPreload());
    // await dispatch( hideIconRequestErrors() );

    const result = await getUsersPermissionsByPaginateService(page);

    if (result.ok) {
      await dispatch(setUsersPemissionsRedux(result.data));
    }

    dispatch(unCheckingPreload());

    return result;
  };
};

export const storeDetailUserPermission = (userPermissionId: string, applicationId: string): any => {
  return async (dispatch: any) => {
    await dispatch(checkingPreload());

    const result = await getUserPermissionsDetailService(userPermissionId, applicationId);

    dispatch(unCheckingPreload());

    if (result.ok) {
      await dispatch(customerPermissionsListRedux(result.data.permissionsCompany));
      await dispatch(setUserPemissionsRedux(result.data.userPermissions));
      await dispatch(setApplicationsListRedux(result.data.userPemissionsAssigned));
      await dispatch(setUserPemissionsAssignedRedux(result.data.userPemissionsAssigned));
      console.log('comunidaddadad');
      // ss
      console.log(result.data);
    }

    return result;
  };
};

export const storeDetailEditUserPermission = (userPermissions: any): any => {
  return async (dispatch: any) => {
    await dispatch(checkingPreload());

    console.log('userPermissionsuserPermissionsuserPermissions ', userPermissions);
    const dataSave = {
      permissions: userPermissions.permissions,
      userId: userPermissions.userPermissionId,
    };

    const result = await updateUserPemissionsService(dataSave);

    dispatch(unCheckingPreload());

    if (result.ok) {
      await dispatch(setUsersPemissionsRedux(result.data));
    }

    console.log('chuchuchurrumi');
    console.log(result);

    return result;
  };
};
